import { getVendorBoothUrl } from '@hopin-team/dashboard-constants';
import { useVendorId } from '@hopin-team/dashboard-shared-react';
import { useTranslation } from '@hopin-team/provider-translation';
import { Loading } from '@hopin-team/ui-loading';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';

export const VendorBooth = () => {
  const vendorId = useVendorId(window.location.pathname);
  const [loaded, setLoaded] = useState(false);
  const { t, i18n } = useTranslation();

  // switching language reloads the iframe
  useEffect(() => {
    setLoaded(false);
  }, [i18n.language]);

  const onLoad = () => {
    setLoaded(true);
  };

  if (!vendorId) {
    return (
      <Loading
        text={t('vendorBooth.loading')}
        poweredByText={t('vendorBooth.poweredBy')}
      />
    );
  }

  return (
    <>
      {!loaded && (
        <Loading
          text={t('vendorBooth.loading')}
          poweredByText={t('vendorBooth.poweredBy')}
        />
      )}
      <iframe
        className={cx(
          'w-full h-[calc(100vh-0.5em)] border-0 mx-auto',
          loaded ? 'block' : 'hidden',
        )}
        onLoad={onLoad}
        title={t('vendorBooth.editBoothDetails')}
        src={`${getVendorBoothUrl()}/${vendorId}/edit?standalone=true&locale=${
          i18n.language
        }`}
      />
    </>
  );
};
